'use client';
import RatingStars from '@/components/shared/rating-stars/rating-stars.component';
import Typography from '@/components/shared/typography/typography.component';
import classes from './styles.module.scss';

export default function TestimonialItem({
    verbatim,
    name,
    rating,
}: {
    verbatim: string;
    name: string;
    rating: number;
}) {
    return (
        <div className={classes.testimonialItem}>
            <div className={classes.reviewContainer}>
                <div className={classes.review}>
                    <Typography variant={'subtitle1'}>{verbatim}</Typography>
                </div>
            </div>
            <div className={classes.attributionContainer}>
                <div className={classes.nameAndDate}>
                    <Typography
                        variant={'subtitle2Medium'}
                    >{`— ${name}`}</Typography>
                </div>
                <RatingStars rating={rating} />
            </div>
        </div>
    );
}
